<template>
  <div>
    <e-sidebar
      :title="edit ? $t('Editar Fornecedor de Delivery') : $t('Novo Fornecedor de Delivery')"
      :show="showSidebar"
      :fetching="fetching"
      :saving="saving"
      width="500px"
      @save="saveDeliverySupplier"
      @hidden="hideSidebar"
    >
      <template #content>
        <FormulateForm
          ref="deliverySupplierForm"
          name="deliverySupplierForm"
        >
          <FormulateInput
            id="delivery-supplier-name"
            v-model="localDeliverySupplier.name"
            type="text"
            class="required"
            maxlength="100"
            :label="$t('Nome')"
            validation="required"
          />
          <FormulateInput
            id="delivery-supplier-supplier"
            v-model="localDeliverySupplier.supplier"
            type="vue-select"
            class="required"
            :label="$t('Integração')"
            :instruction="
              $t('Serviço externo utilizado para solicitar as entregas deste fornecedor.')
            "
            :placeholder="$t('Selecione')"
            :options="deliverySupplierOptions()"
            validation="required"
          />
          <FormulateInput
            id="delivery-supplier-active"
            v-model="localDeliverySupplier.active"
            type="switch"
            :label="$t('Ativo')"
          />
        </FormulateForm>
      </template>
    </e-sidebar>
  </div>
</template>

<script>
import { ESidebar } from '@/views/components'
import { deliveryDomain } from '@/mixins'

const getInitialLocalDeliverySupplier = () => ({
  id: null,
  name: '',
  supplier: null,
  active: true,
})

export default {
  components: {
    ESidebar,
  },

  mixins: [deliveryDomain],

  data() {
    return {
      showSidebar: false,
      fetching: false,
      edit: false,
      saving: false,
      localDeliverySupplier: getInitialLocalDeliverySupplier(),
    }
  },

  methods: {
    showCreate() {
      this.localDeliverySupplier = getInitialLocalDeliverySupplier()
      this.edit = false
      this.showSidebar = true
    },

    async show({ id } = {}) {
      if (!id) {
        this.showCreate()
        return
      }

      this.edit = true
      this.showSidebar = true
      try {
        this.fetching = true
        const { data } = await this.$http.get(`/api/sales/delivery-suppliers/${id}`)
        this.localDeliverySupplier = { ...data }
      } catch (error) {
        this.showGenericError({ error })
        this.hideSidebar()
      } finally {
        this.fetching = false
      }
    },

    hideSidebar() {
      this.localDeliverySupplier = getInitialLocalDeliverySupplier()
      this.showSidebar = false
    },

    async saveDeliverySupplier() {
      this.$refs.deliverySupplierForm.showErrors()
      if (!this.$refs.deliverySupplierForm.isValid) {
        this.showInvalidDataMessage()
        return
      }

      try {
        this.saving = true
        const body = {
          id: this.localDeliverySupplier.id,
          name: this.localDeliverySupplier.name,
          supplier: this.localDeliverySupplier.supplier,
          active: this.localDeliverySupplier.active,
        }
        const result = await this.$http({
          url: '/api/sales/delivery-suppliers',
          method: this.edit ? 'PUT' : 'POST',
          data: body,
        })

        this.showSuccess({
          message: this.$t(`${this.edit ? 'Atualização' : 'Inclusão'} realizada com sucesso`),
        })
        this.showSidebar = false
        this.$emit('save', result.data)
      } catch (error) {
        this.showError({ error })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style></style>
